/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { SignRequestBuilderRequestsMetadata, type SignRequestBuilder } from './sign/index.js';
// @ts-ignore
import { SigningRequestBuilderNavigationMetadata, type SigningRequestBuilder } from './signing/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /contracts/{contract-id}/mandate
 */
export interface MandateRequestBuilder extends BaseRequestBuilder<MandateRequestBuilder> {
    /**
     * The sign property
     */
    get sign(): SignRequestBuilder;
    /**
     * The signing property
     */
    get signing(): SigningRequestBuilder;
    /**
     * GetMandateDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * GetMandateDocument
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const MandateRequestBuilderUriTemplate = "{+baseurl}/contracts/{contract%2Did}/mandate";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const MandateRequestBuilderNavigationMetadata: Record<Exclude<keyof MandateRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    sign: {
        requestsMetadata: SignRequestBuilderRequestsMetadata,
    },
    signing: {
        navigationMetadata: SigningRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const MandateRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: MandateRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
